import iFrameResize from "./iframeResizer";
const rb_owner_key = "c9ed4420-3811-11ee-a908-83aad5f5c937";
const thread_uri = window.location.href;
const thread_title = window.document.title;
const thread_fragment = window.location.hash;

// rb owner was here.
const rb_src =
  "https://my.remarkbox.com/embed" +
  "?rb_owner_key=" +
  rb_owner_key +
  "&thread_title=" +
  encodeURI(thread_title) +
  "&thread_uri=" +
  encodeURIComponent(thread_uri) +
  thread_fragment;

function create_remarkbox_iframe() {
  const parent = document.getElementById("remarkbox-div");
  if (parent === null) {
    return;
  }
  const ifrm = document.createElement("iframe");
  ifrm.setAttribute("id", "remarkbox-iframe");
  ifrm.setAttribute("scrolling", "no");
  ifrm.setAttribute("src", rb_src);
  ifrm.setAttribute("frameborder", "0");
  ifrm.setAttribute("tabindex", "0");
  ifrm.setAttribute("title", "Remarkbox");
  ifrm.style.width = "100%";
  parent.appendChild(ifrm);
}
create_remarkbox_iframe();
iFrameResize(
  {
    checkOrigin: ["https://my.remarkbox.com"],
    inPageLinks: true,
    initCallback: function (e) {
      e.iFrameResizer.moveToAnchor(thread_fragment);
    },
  },
  document.getElementById("remarkbox-iframe")
);
